import { LayoutGrid, List } from 'lucide-react';

import { ToggleGroup, ToggleGroupItem } from '@/design-system/components/ui';

interface Props {
  viewMode: 'list' | 'card';
  onChange: (mode: 'list' | 'card') => void;
}

export const TriggerTypeViewToggle = ({ viewMode, onChange }: Props) => {
  return (
    <ToggleGroup
      type="single"
      value={viewMode}
      onValueChange={(val) => {
        if (val) onChange(val as 'list' | 'card');
      }}
      aria-label="view mode"
    >
      <ToggleGroupItem value="list" aria-label="list view" size="sm">
        <List size={20} />
      </ToggleGroupItem>
      <ToggleGroupItem value="card" aria-label="card view" size="sm">
        <LayoutGrid size={20} />
      </ToggleGroupItem>
    </ToggleGroup>
  );
};
